import { Box, Checkbox, FormControlLabel } from "@mui/material"
import { prevent } from "lib/prevent"
import { useSelectedId } from "routes/schedule/lib/useSelectedId"
import { ScheduleTreeBar, SelectedComponent } from "slot-definitions"
import { BlockClicks } from "lib/@components/block-clicks"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RegimeDraftLockHide } from "routes/regime/regime-draft-locking/regime-draft-lock-hide"
import { NotInSharing } from "lib/@components/sharing/not-in-sharing"
import { IfMultiSelect } from "../lib/if-multi-select"

ScheduleTreeBar.plug(
    <RegimeDraftLockHide if={(c) => !c.hideSelected}>
        <Selected />
    </RegimeDraftLockHide>
)

export function Selected({ id, showLabel, ...props }) {
    const { target, parentItem, isMultiSelect } = useBoundContext()
    id = id || target.selectedId || target.id
    const [isSelected, toggle, isAbsolute] = useSelectedId([target._id, id])

    if (target.retired) return null

    return (
        <NotInSharing>
            <IfMultiSelect condition={isMultiSelect}>
                <SelectedComponent.Slot type={parentItem?.id}>
                    <BlockClicks>
                        <Box
                            className="selected-box menu-pad"
                            sx={{
                                "& .Mui-checked svg": {
                                    color: isAbsolute ? "primary.main" : "text.primary",
                                },
                            }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        className={`checkbox ${isSelected ? "checked" : "not-checked"}`}
                                        {...props}
                                        key={id}
                                        checked={isSelected}
                                        onClick={prevent(() => toggle(isSelected ? false : id))}
                                        data-cy="selected-checkbox"
                                    />
                                }
                                label={showLabel ? "Selected" : undefined}
                            />
                        </Box>
                    </BlockClicks>
                </SelectedComponent.Slot>
            </IfMultiSelect>
        </NotInSharing>
    )
}
